module.exports = __webpack_public_path__ + "img/puit-climatique.c13b20e7.svg";